import type { FacetName, Rule, Rules } from '@/api/types';

/** Convert Explore query + facet selections into segment rules (see spec §8.3). */
export function rulesFromExplore({ q, semantic, threshold, facets }: { q: string; semantic: boolean; threshold: number; facets: Record<FacetName, string[]> }): Rules {
  const include: Rule[] = [];
  if (facets.topics.length) include.push({ field: 'topics', op: 'contains_any', value: facets.topics });
  if (facets.brands.length) include.push({ field: 'brands', op: 'contains_any', value: facets.brands });
  if (facets.setting.length) include.push({ field: 'setting', op: 'in', value: facets.setting });
  if (facets.sentiment.length) include.push({ field: 'sentiment', op: 'in', value: facets.sentiment });
  if (facets.iab.length) include.push({ field: 'iab_categories', op: 'contains_any', value: facets.iab });
  if (facets.risk.length) include.push({ field: 'brand_safety.risk', op: 'in', value: facets.risk });
  if (facets.channel.length) include.push({ field: 'channel', op: 'in', value: facets.channel });
  if (q.trim()) {
    if (semantic) include.push({ field: 'semantic', op: 'similar_to', value: q.trim(), threshold });
    else include.push({ field: 'transcript', op: 'text_match', value: q.trim() });
  }
  return { include, exclude: [] };
}
